import { render, staticRenderFns } from "./designelementsList.vue?vue&type=template&id=0be23da4"
import script from "./designelementsList.vue?vue&type=script&lang=js"
export * from "./designelementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports